import type { IDownloadIconProps } from './helpers';

export const DownloadIcon = ({ variant = 'default', ...props }: IDownloadIconProps) => {
	if (variant === 'plain')
		return (
			<svg
				width='18'
				height='18'
				viewBox='0 0 18 18'
				fill='none'
				xmlns='http://www.w3.org/2000/svg'
				{...props}
			>
				<path
					opacity='0.4'
					d='M15.0289 7.46909H12.9102C11.1727 7.46909 9.75778 6.05417 9.75778 4.31668V2.19796C9.75778 1.79475 9.42788 1.46484 9.02466 1.46484H5.91624C3.65823 1.46484 1.83276 2.93108 1.83276 5.54832V12.0437C1.83276 14.661 3.65823 16.1272 5.91624 16.1272H11.6786C13.9366 16.1272 15.762 14.661 15.762 12.0437V8.20221C15.762 7.79899 15.4321 7.46909 15.0289 7.46909Z'
					fill='#566F83'
				/>
				<path
					d='M11.5833 1.61942C11.2827 1.31884 10.7622 1.52411 10.7622 1.94199V4.50057C10.7622 5.57093 11.6713 6.458 12.7783 6.458C13.4747 6.46533 14.4425 6.46533 15.2709 6.46533C15.6888 6.46533 15.9087 5.97414 15.6155 5.68089C14.5598 4.61787 12.6683 2.70443 11.5833 1.61942Z'
					fill='#566F83'
				/>
				<path
					d='M9.0027 10.793C8.7901 10.5804 8.4382 10.5804 8.2256 10.793L7.69775 11.3208V8.24906C7.69775 7.94848 7.44849 7.69922 7.14791 7.69922C6.84733 7.69922 6.59807 7.94848 6.59807 8.24906V11.3208L6.07023 10.793C5.85762 10.5804 5.50572 10.5804 5.29312 10.793C5.08052 11.0056 5.08052 11.3575 5.29312 11.5701L6.75936 13.0363C6.76669 13.0437 6.77402 13.0437 6.77402 13.051C6.81801 13.095 6.87666 13.1316 6.93531 13.161C7.00862 13.1829 7.0746 13.1976 7.14791 13.1976C7.22122 13.1976 7.2872 13.1829 7.35318 13.1536C7.41917 13.1243 7.47781 13.0876 7.53646 13.0363L9.0027 11.5701C9.21531 11.3575 9.21531 11.0056 9.0027 10.793Z'
					fill='#566F83'
				/>
			</svg>
		);

	if (variant === 'outline')
		return (
			<svg
				width='14'
				height='14'
				viewBox='0 0 14 14'
				fill='none'
				xmlns='http://www.w3.org/2000/svg'
			>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M2.87606 2.49163C3.76963 1.50606 5.15556 1.16602 7.0232 1.16602C7.56377 1.16602 8.06239 1.19601 8.51174 1.25756C8.60277 1.27003 8.68756 1.31084 8.75409 1.37421L12.0616 4.52421C12.1288 4.58818 12.1739 4.67184 12.1904 4.76311C12.3073 5.40905 12.3607 6.15414 12.3607 6.99935C12.3607 9.04092 12.0581 10.5375 11.1752 11.5095C10.2807 12.4943 8.89315 12.8327 7.0232 12.8327C5.15599 12.8327 3.7699 12.4943 2.87618 11.5094C1.99412 10.5374 1.69153 9.04094 1.69153 6.99935C1.69153 4.96048 1.99418 3.4643 2.87606 2.49163ZM3.52429 3.07936C2.87637 3.79398 2.56653 4.99571 2.56653 6.99935C2.56653 9.00609 2.87644 10.2076 3.52416 10.9214C4.16024 11.6223 5.22124 11.9577 7.0232 11.9577C8.82824 11.9577 9.89072 11.6223 10.5275 10.9212C11.1758 10.2075 11.4857 9.00611 11.4857 6.99935C11.4857 6.25181 11.4419 5.60742 11.3531 5.05781L8.25459 2.10683C7.88658 2.06332 7.47511 2.04102 7.0232 2.04102C5.22166 2.04102 4.16051 2.37764 3.52429 3.07936Z'
					fill='white'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M8.1283 1.21484C8.36992 1.21484 8.5658 1.41072 8.5658 1.65234V3.20459C8.5658 4.04663 9.24825 4.72884 10.0906 4.72884H11.812C12.0537 4.72884 12.2495 4.92472 12.2495 5.16634C12.2495 5.40797 12.0537 5.60384 11.812 5.60384H10.0906C8.76534 5.60384 7.6908 4.53022 7.6908 3.20459V1.65234C7.6908 1.41072 7.88667 1.21484 8.1283 1.21484Z'
					fill='white'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M6.80188 5.38281C7.0435 5.38281 7.23938 5.57869 7.23938 5.82031V9.34423C7.23938 9.58585 7.0435 9.78173 6.80188 9.78173C6.56026 9.78173 6.36438 9.58585 6.36438 9.34423V5.82031C6.36438 5.57869 6.56026 5.38281 6.80188 5.38281Z'
					fill='white'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M5.12477 7.65873C5.29599 7.48824 5.573 7.48883 5.74349 7.66005L6.80139 8.72246L7.85929 7.66005C8.02978 7.48883 8.30679 7.48824 8.47801 7.65873C8.64922 7.82922 8.64981 8.10623 8.47932 8.27745L7.1114 9.6512C7.0293 9.73365 6.91774 9.78 6.80139 9.78C6.68503 9.78 6.57347 9.73365 6.49137 9.6512L5.12345 8.27745C4.95296 8.10623 4.95355 7.82922 5.12477 7.65873Z'
					fill='white'
				/>
			</svg>
		);

	return (
		<svg
			width='41'
			height='41'
			viewBox='0 0 41 41'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			{...props}
		>
			<rect
				x='0.5'
				y='0.5'
				width='40'
				height='40'
				rx='20'
				fill='#FFEEFF'
			/>
			<path
				opacity='0.4'
				d='M26.1665 19.2933H24.2398C22.6598 19.2933 21.3732 18.0066 21.3732 16.4266V14.4999C21.3732 14.1333 21.0732 13.8333 20.7065 13.8333H17.8798C15.8265 13.8333 14.1665 15.1666 14.1665 17.5466V23.4533C14.1665 25.8333 15.8265 27.1666 17.8798 27.1666H23.1198C25.1732 27.1666 26.8332 25.8333 26.8332 23.4533V19.9599C26.8332 19.5933 26.5332 19.2933 26.1665 19.2933Z'
				fill='#8B1169'
			/>
			<path
				d='M23.0333 13.9734C22.76 13.7001 22.2866 13.8867 22.2866 14.2667V16.5934C22.2866 17.5667 23.1133 18.3734 24.12 18.3734C24.7533 18.3801 25.6333 18.3801 26.3866 18.3801C26.7666 18.3801 26.9666 17.9334 26.7 17.6667C25.74 16.7001 24.02 14.9601 23.0333 13.9734Z'
				fill='#8B1169'
			/>
			<path
				d='M20.6868 22.3133C20.4935 22.12 20.1735 22.12 19.9801 22.3133L19.5001 22.7933V20C19.5001 19.7267 19.2735 19.5 19.0001 19.5C18.7268 19.5 18.5001 19.7267 18.5001 20V22.7933L18.0201 22.3133C17.8268 22.12 17.5068 22.12 17.3135 22.3133C17.1201 22.5067 17.1201 22.8267 17.3135 23.02L18.6468 24.3533C18.6535 24.36 18.6601 24.36 18.6601 24.3667C18.7001 24.4067 18.7535 24.44 18.8068 24.4667C18.8735 24.4867 18.9335 24.5 19.0001 24.5C19.0668 24.5 19.1268 24.4867 19.1868 24.46C19.2468 24.4333 19.3001 24.4 19.3535 24.3533L20.6868 23.02C20.8801 22.8267 20.8801 22.5067 20.6868 22.3133Z'
				fill='#8B1169'
			/>
		</svg>
	);
};
